import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './Shop.css';

const SITE = "https://juanipavlovsky.com.ar";

const Shop = () => {
  const blockContext = (e) => e.preventDefault();
  const blockDrag = (e) => e.preventDefault();

  return (
    <>
      <Helmet>
        <title>Shop</title>
        <meta name="description" content="Obras, libros y ediciones limitadas para decorar tus espacios." />
        <link rel="canonical" href={`${SITE}/shop`} />
        <meta property="og:title" content="Shop | Juani Pavlovsky" />
        <meta property="og:url" content={`${SITE}/shop`} />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Inicio", "item": `${SITE}/` },
            { "@type": "ListItem", "position": 2, "name": "Shop", "item": `${SITE}/shop` }
          ]
        })}</script>

      </Helmet>
      <div className="shop-container">
        <h1 className="shop-title">Shop</h1>

        {/* 1 - Imagen izquierda (default) */}
        <div className="shop-section">
          <div className="shop-image-container">
            <img
              src="/images/fondo-libros.jpg"
              alt="Libros de Juani Pavlovsky"
              loading="lazy"
              draggable="false"
              onContextMenu={blockContext}
              onDragStart={blockDrag}
            />
          </div>
          <div className="shop-text">
            <h2>Libros</h2>
            <p>Explorá las publicaciones de Juani, donde fusiona fotografía, poesía y reflexiones visuales.</p>
            <Link to="/shop/libros" className="shop-btn">Ver libros</Link>
          </div>
        </div>

        {/* 2 - Imagen derecha */}
        <div className="shop-section reverse">
          <div className="shop-image-container">
            <img
              src="/images/espiral.jpg"
              alt="Obra destacada"
              loading="lazy"
              draggable="false"
              onContextMenu={blockContext}
              onDragStart={blockDrag}
            />
          </div>
          <div className="shop-text">
            <h2>Obras</h2>
            <p>Descubrí obras originales, impresiones fine art y ediciones limitadas para decorar tus espacios.</p>
            <Link to="/shop/obras" className="shop-btn">Ver obras</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Shop;
